import React, { useEffect } from 'react';

const PrivacyPolicy = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="privacy-page py-5 bg-light">
            <div className="container py-5">
                <div className="card border-0 shadow-sm p-5 rounded-4">
                    <h1 className="fw-bold mb-4 text-primary">Privacy Policy</h1>
                    <p className="text-muted mb-5 italic">Last updated: December 22, 2025</p>

                    <section className="mb-5">
                        <h4 className="fw-bold">1. Introduction</h4>
                        <p>
                            Welcome to Secure360 ("we," "our," or "us"). We are committed to protecting your personal information and your right to privacy.
                            This Privacy Policy explains how we collect, use, and disclose your information when you use our security scanning services.
                        </p>
                    </section>

                    <section className="mb-5">
                        <h4 className="fw-bold">2. Data We Collect</h4>
                        <div className="ps-3 border-start border-3 border-primary-subtle">
                            <p><strong>Personal Information:</strong> When you register, we collect your email address and username.</p>
                            <p><strong>Scan Data:</strong> We collect domain names and IP addresses you submitted for scanning to provide our security services.</p>
                            <p><strong>Technical Data:</strong> We automatically collect log data including IP addresses, browser types, and system info to improve platform security.</p>
                        </div>
                    </section>

                    <section className="mb-5">
                        <h4 className="fw-bold">3. How We Use Your Data</h4>
                        <ul>
                            <li>To provide and maintain our security monitoring platform.</li>
                            <li>To notify you about changes or security alerts related to your assets.</li>
                            <li>To detect, prevent, and address technical or security issues.</li>
                            <li>To provide customer support.</li>
                        </ul>
                    </section>

                    <section className="mb-5">
                        <h4 className="fw-bold">4. Data Security</h4>
                        <p>
                            The security of your data is our priority. While we strive to use enterprise-grade means to protect your information,
                            no method of transmission over the Internet is 100% secure. We implement strictly encrypted storage for all sensitive user credentials.
                        </p>
                    </section>

                    <section className="mb-5">
                        <h4 className="fw-bold">5. Third-Party Services</h4>
                        <p>
                            We may employ third-party companies and individuals to facilitate our scanning (e.g., global threat databases).
                            These third parties have access to your info only to perform these tasks on our behalf and are obligated not to disclose or use it for any other purpose.
                        </p>
                    </section>

                    <section className="mb-5 border-top pt-4">
                        <h4 className="fw-bold text-primary-emphasis">Contact Us</h4>
                        <p className="mb-0">If you have any questions about this Privacy Policy, please contact us at:</p>
                        <p className="fw-bold">privacy@secure360.us</p>
                    </section>
                </div>
            </div>
        </div>
    );
};

export default PrivacyPolicy;
